import { Box } from '@wix/design-system';
import React from 'react';

export const MAX_FONT_SIZE = 22;

export const DATA_HOOKS = {
  TEXT_GROUP_PREVIEW: 'text-group-preview',
  BORDER_GROUP_PREVIEW: 'border-group-preview',
  SHADOW_GROUP_PREVIEW: 'boxShadow-group-preview',
  BORDER_RADIUS_GROUP_PREVIEW: 'borderRadius-group-preview',
  FONT_SIZE: 'font-size',
  FONT_FAMILY: 'font-family',
  GROUP_PREVIEW: 'group-preview',
  DISABLED_GROUP_PREVIEW: 'disabled-group-preview',
  EMPTY_LABEL: 'empty-label',
  BORDER_COLOR: 'border-color',
  BORDER_WIDTH: 'border-width',
  BORDER_STYLE: 'border-style',
  BORDER_RADIUS_VALUE: 'border-radius-value',
  BORDER_RADIUS_ICON_SQUARE: 'border-radius-icon-square',
  BORDER_RADIUS_ICON_ROUNDED: 'border-radius-icon-rounded',
  BORDER_RADIUS_ICON_ROUND: 'border-radius-icon-round',
  SHADOW_POSITION: 'shadow-position',
  BOX_SHADOW_PREVIEW: 'box-shadow-preview',
};

export const BorderColorIcon = ({ color }: { color: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <mask id="a" fill="#fff">
      <path d="M12 0c6.6274 0 12 5.3726 12 12s-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0Zm0 5c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7Z" />
    </mask>
    <path
      fill={color}
      d="M12 0c6.6274 0 12 5.3726 12 12s-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0Zm0 5c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7Z"
    />
    <path
      fill={color}
      fillOpacity=".1"
      d="M12 0v1c6.0751 0 11 4.9249 11 11h2c0-7.1797-5.8203-13-13-13v1Zm12 12h-1c0 6.0751-4.9249 11-11 11v2c7.1797 0 13-5.8203 13-13h-1ZM12 24v-1C5.9249 23 1 18.0751 1 12h-2c0 7.1797 5.8203 13 13 13v-1ZM0 12h1C1 5.9249 5.9249 1 12 1v-2C4.8203-1-1 4.8203-1 12h1Zm12-7V4c-4.4183 0-8 3.5817-8 8h2c0-3.3137 2.6863-6 6-6V5Zm-7 7H4c0 4.4183 3.5817 8 8 8v-2c-3.3137 0-6-2.6863-6-6H5Zm7 7v1c4.4183 0 8-3.5817 8-8h-2c0 3.3137-2.6863 6-6 6v1Zm7-7h1c0-4.4183-3.5817-8-8-8v2c3.3137 0 6 2.6863 6 6h1Z"
      mask="url(#a)"
    />
  </svg>
);

export const BorderRadiusIconSquare = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-hook={DATA_HOOKS.BORDER_RADIUS_ICON_SQUARE}
  >
    <g clipPath="url(#clip0_3257_103798)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 6V20H19V5H4V6H18Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3257_103798">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BorderRadiusIconRound = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-hook={DATA_HOOKS.BORDER_RADIUS_ICON_ROUNDED}
  >
    <g clipPath="url(#clip0_3931_121846)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 6H4V5H14.5C16.9853 5 19 7.01472 19 9.5V20H18V9.5C18 7.567 16.433 6 14.5 6Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3931_121846">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BorderRadiusIconCircular = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-hook={DATA_HOOKS.BORDER_RADIUS_ICON_ROUND}
  >
    <g clipPath="url(#clip0_3257_103801)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 20C18 12 12 6 4 6V5C13 5 19 11 19 20H18Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3257_103801">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PrefixContainer = ({
  children,
  innerWidth = 24,
  innerHeight = 24,
}: {
  children: React.ReactNode;
  innerWidth?: number;
  innerHeight?: number;
}) => {
  return (
    <Box
      align="center"
      height="34px"
      width="34px"
      alignSelf="center"
      style={{ pointerEvents: 'none' }}
    >
      <Box width={innerWidth} height={innerHeight} alignSelf="center">
        {children}
      </Box>
    </Box>
  );
};

export const mixedColor = 'linear-gradient(#4F75FF, #FF0000)';

const BorderStyleSolid = (
  <svg width="100%" height="6" xmlns="http://www.w3.org/2000/svg">
    <line
      x1="0"
      y1="3"
      x2="100%"
      y2="3"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

const BorderStyleDashed = (
  <svg width="100%" height="6" xmlns="http://www.w3.org/2000/svg">
    <line
      x1="0"
      y1="3"
      x2="100%"
      y2="3"
      stroke="currentColor"
      strokeWidth="2"
      strokeDasharray="6 4"
    />
  </svg>
);

const BorderStyleDotted = (
  <svg width="100%" height="6" xmlns="http://www.w3.org/2000/svg">
    <line
      x1="0"
      y1="3"
      x2="100%"
      y2="3"
      stroke="currentColor"
      strokeWidth="2"
      strokeDasharray="2 3"
      strokeLinecap="round"
    />
  </svg>
);

const BorderStyleDouble = (
  <svg width="100%" height="8" xmlns="http://www.w3.org/2000/svg">
    <line
      x1="0"
      y1="1"
      x2="100%"
      y2="1"
      stroke="currentColor"
      strokeWidth="1"
    />
    <line
      x1="0"
      y1="7"
      x2="100%"
      y2="7"
      stroke="currentColor"
      strokeWidth="1"
    />
  </svg>
);

export const valueToIcon: Record<string, React.ReactElement> = {
  solid: BorderStyleSolid,
  dashed: BorderStyleDashed,
  dotted: BorderStyleDotted,
  double: BorderStyleDouble,
};
